class captchaUtil {
  initialize(formName = 'contact_form') {
    const googleRecaptchaClientSide = document.querySelector('input[name="googleRecaptchaClientSide"]');
    if (googleRecaptchaClientSide) {
      grecaptcha.ready(function () {
        grecaptcha.execute(googleRecaptchaClientSide.value, { action: formName }).then(function (token) {
          $(googleRecaptchaClientSide).parent().prepend(`<input type="hidden" name="googleRecaptchaToken" value="${token}">`);
          $(googleRecaptchaClientSide).parent().prepend(`<input type="hidden" name="googleRecaptchaAction" value="${formName}">`);
        });
        setInterval(function () {
          grecaptcha.execute(googleRecaptchaClientSide.value, { action: formName }).then(function (token) {
            $('input[name=googleRecaptchaToken]').val(token);
          });
        }, 90000); // tokens gets marked as expired after 2 mins https://github.com/google/recaptcha/issues/302
      });
    }
  }
}

const CaptchaUtil = new captchaUtil();
export default CaptchaUtil;



// WEBPACK FOOTER //
// ./assets/scripts/util/captchaUtil.js